import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'utrakk-redirect',
    path: '/utrakk',
    component: () => import('@/modules/utrakk/containers/utrakk-redirect.container.vue'),
    meta: {
      requiresAuth: true,
      layout: 'home',
      allowedRoles: [...allowed.utrakk.roles],
      breadcrumb: {
        label: 'core.menu.modules.utrakk',
        route: 'utrakk-redirect',
      },
    },
  },
]

export default routes
